import styled from "styled-components";
import { Drawer } from "antd";

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-header {
    border-bottom: 1px solid #f4f4f5;
  }

  .ant-drawer-title {
    color: rgba(0, 0, 0, 0.88);
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    font-weight: 600;
  }

  .ant-drawer-close {
    color: rgba(0, 0, 0, 0.65);
  }

  .ant-drawer-footer {
    padding: 12px 16px;
  }
`;

export const FooterActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const FooterRightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DeleteButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 16px;
  border: 1px solid #f5222d;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  color: #f5222d;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;

  &:hover {
    background: rgba(245, 34, 45, 0.06);
  }
`;

export const CancelButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 16px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.88);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;

  &:hover {
    border-color: #11a7d9;
  }
`;

export const SubmitButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 16px;
  border: 1px solid #11a7d9;
  border-radius: 6px;
  background: #11a7d9;
  cursor: pointer;
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;

  &:hover {
    background: #0f97c4;
    border-color: #0f97c4;
  }

  &:disabled {
    background: #f5f5f5;
    border-color: #e4e4e7;
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
  }
`;

export const InlineWarning = styled.p`
  margin: -12px 0 20px;
  color: #f5222d;
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
`;

export const InfoBox = styled.div`
  display: flex;
  gap: 10px;
  padding: 12px 14px;
  margin: 4px 0 20px;
  background: #e6f4ff;
  border: 1px solid #bae0f5;
  border-radius: 8px;
`;

export const InfoIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-top: 2px;
  border-radius: 50%;
  background: #11a7d9;
  color: #fff;
  flex-shrink: 0;
`;

export const InfoTextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const InfoTitle = styled.span`
  color: #0a5f7c;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
`;

export const InfoText = styled.p`
  margin: 0;
  color: #0a5f7c;
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
`;
